import { render, staticRenderFns } from "./PostHeader.vue?vue&type=template&id=19cc29e6&scoped=true&"
import script from "./PostHeader.vue?vue&type=script&lang=js&"
export * from "./PostHeader.vue?vue&type=script&lang=js&"
import style0 from "./PostHeader.vue?vue&type=style&index=0&id=19cc29e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cc29e6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostHeader.vue
// module id = 245
// module chunks = 0